export default __webpack_public_path__ + "static/media/token.8b4d315c.png";